module.exports = __webpack_public_path__ + "static/img/book3.27094c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book3.jpg
// module id = 0zLD
// module chunks = 1